function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ALLPAGOCREDITCARD, CREDITCARD } from 'researcher/domain/transaction/payment-method';
import AllpagoCreditCardForm from './AllpagoCreditCardForm';
import BraintreeCreditCardForm from './BraintreeCreditCardForm';
var CreditCardForm = function CreditCardForm(_ref) {
  var convertNumberOfInstallments = _ref.convertNumberOfInstallments,
    currency = _ref.currency,
    receiptCode = _ref.receiptCode,
    _registerPreProcessor = _ref.registerPreProcessor,
    total = _ref.total,
    userCountry = _ref.userCountry;
  var methods = useFormContext();
  var _methods$watch = methods.watch(['paymentMethodId', 'requestAllpago', 'usingFapespFunds']),
    _methods$watch2 = _slicedToArray(_methods$watch, 3),
    paymentMethodId = _methods$watch2[0],
    requestAllpago = _methods$watch2[1],
    usingFapespFunds = _methods$watch2[2];
  if ([ALLPAGOCREDITCARD, CREDITCARD].indexOf(paymentMethodId) === -1) {
    return null;
  }
  var useAllpago = userCountry === 'BR' && !usingFapespFunds && requestAllpago;
  return /*#__PURE__*/React.createElement(React.Fragment, null, useAllpago ? /*#__PURE__*/React.createElement(AllpagoCreditCardForm, {
    convertTotal: convertNumberOfInstallments,
    currency: currency,
    receiptCode: receiptCode,
    registerPreProcessor: function registerPreProcessor(fn) {
      return _registerPreProcessor(ALLPAGOCREDITCARD, fn);
    },
    total: total
  }) : /*#__PURE__*/React.createElement(BraintreeCreditCardForm, {
    currency: currency,
    registerProcessor: function registerProcessor(fn) {
      return _registerPreProcessor(CREDITCARD, fn);
    }
  }));
};
export default CreditCardForm;